import React, { HTMLAttributes } from 'react';
import styles from './SectionBlock.module.css';

type SectionBlockSpacing = 'divider' | 'margin' | 'none';

interface SectionBlockProps extends HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  spacing?: SectionBlockSpacing;
}

const spacingClassNameMap: Record<SectionBlockSpacing, string> = {
  divider: styles.divider,
  margin: styles.margin,
  none: '',
};

const SectionBlock: React.FC<SectionBlockProps> = ({
  children,
  className = '',
  spacing = 'none',
  ...rest
}) => {
  const classes = [styles.block, spacingClassNameMap[spacing], className].filter(Boolean).join(' ');

  return (
    <div className={classes} {...rest}>
      {children}
    </div>
  );
};

export default SectionBlock;